export enum SessionResumeConstants {
  SET_SESSION_RESUME_SHOW_MODAL = 'session/SET_SESSION_RESUME_SHOW_MODAL',
  SET_USER = 'session/SET_USER',
  RESET_SESSION = 'session/RESET_SESSION',
}

export const DISABLE_SESSION_TIMEOUT = 999999
